import type { FC } from 'react';
import React from 'react';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import type { TPagination } from './models';
import { OFFSET_LIMIT_PAGINATION } from './constants';

export const Pagination: FC<TPagination> = ({
    PaginationProvider,
    PaginationShowMoreButton,
    analytics,
    elementsCount,
    isLoading = false,
    limit = OFFSET_LIMIT_PAGINATION,
    onShowMoreButtonClick,
    currentPageNumber,
}) => {
    const handleShowMoreClick = () => {
        sendEvent(analytics?.paginationShowMoreClick);
        onShowMoreButtonClick();

        if (history && history.scrollRestoration) {
            history.scrollRestoration = 'manual';
        }
    };

    /* istanbul ignore next */
    const emptyOnChangePage = () => {};

    return (
        <PaginationProvider
            currentPageNumber={currentPageNumber}
            elementsCount={elementsCount}
            limit={limit}
            onChangePage={emptyOnChangePage}
            onShowMoreButtonClick={handleShowMoreClick}
        >
            <PaginationShowMoreButton
                buttonSettings={{
                    loading: isLoading,
                    size: 's',
                    block: true,
                }}
            />
        </PaginationProvider>
    );
};
